(function() {
  var CropYear, Service,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  Service = App.loadClass('core::Angular/Service');

  CropYear = App.loadClass('core::CropYear');

  exports.DataSidebarService = (function(superClass) {
    extend(DataSidebarService, superClass);

    function DataSidebarService(http, rootScope, loader) {
      this.http = http;
      this.rootScope = rootScope;
      this.loader = loader;
      this.checkArray = bind(this.checkArray, this);
      this.loadFieldBoundary = bind(this.loadFieldBoundary, this);
      this.downloadRx = bind(this.downloadRx, this);
      this.unlockSidebar = bind(this.unlockSidebar, this);
      this.lockSidebar = bind(this.lockSidebar, this);
      this.data = [];
      this.page_loading = false;
      this.crop_year = (new CropYear()).get();
    }

    DataSidebarService.prototype.lockSidebar = function() {
      return this.loader.overSidebar('Loading...');
    };

    DataSidebarService.prototype.unlockSidebar = function() {
      return this.loader.hideAll();
    };

    DataSidebarService.prototype.initializePage = function() {
      this.loader.overMapAndSidebar('Loading...');
      return this.page_loading = true;
    };

    DataSidebarService.prototype.pageLoaded = function() {
      this.loader.hideAll();
      return this.page_loading = false;
    };

    DataSidebarService.prototype.downloadRx = function(id) {
      return this.http.post('backend/grower/data/download', {
        id: id
      });
    };

    DataSidebarService.prototype.getOperations = function() {
      var operations;
      operations = ['Ears, Rows, and Length', 'Stand Count', 'Harvest Load'].sort();
      return operations;
    };

    DataSidebarService.prototype.postBulkDelete = function(deleteArray) {
      var i, id, layer, layer_id, layer_type, len;
      for (i = 0, len = deleteArray.length; i < len; i++) {
        layer = deleteArray[i];
        id = layer.id;
        layer_id = layer.layer_id;
        layer_type = layer.layer_type;
        switch (layer_type) {
          case 'planting':
            this.http.post('backend/grower/layers/planting/delete', {
              id: id,
              layer_id: layer_id
            });
            break;
          case 'nitrogen':
            this.http.post('backend/grower/layers/nitrogen/delete', {
              id: id,
              layer_id: layer_id
            });
            break;
          case 'fertilizer':
            this.http.post('backend/grower/layers/fertilizer/delete', {
              id: id,
              layer_id: layer_id
            });
            break;
          case 'spraying':
            this.http.post('backend/grower/layers/spraying/delete', {
              id: id,
              layer_id: layer_id
            });
            break;
          case 'stand_count':
            this.http.post('backend/grower/layers/standcount/delete', {
              id: id,
              layer_id: layer_id
            });
            break;
          case 'ears_rows_length':
            this.http.post('backend/grower/layers/ears-rows-length/delete', {
              id: id,
              layer_id: layer_id
            });
            break;
          case 'harvest_load':
            this.http.post('backend/grower/layers/harvest-load/delete', {
              id: id,
              layer_id: layer_id
            });
            break;
          case 'prescription_map':
            this.http.post('backend/grower/layers/prescription-map/delete', {
              id: id,
              layer_id: layer_id
            });
            break;
          case 'shapefile':
            this.http.post('backend/grower/layers/shapefile/delete', {
              id: id,
              layer_id: layer_id
            });
            break;
          case 'planting_rx':
            this.http.post('backend/grower/layers/planting-rx/delete', {
              id: id,
              layer_id: layer_id
            });
            break;
          case 'management_zone':
            this.http.post('backend/grower/layers/management-zones/delete', {
              id: id,
              layer_id: layer_id
            });
            break;
          case 'cover_crop':
            this.http.post('backend/grower/layers/cover-crop/delete', {
              id: id,
              layer_id: layer_id
            });
        }
      }
      return this.http.post('backend/grower/data/ng-bulk-delete-complete');
    };

    DataSidebarService.prototype.getUserType = function() {
      return this.http.post('backend/grower/data/ng-get-user-type');
    };

    DataSidebarService.prototype.loadFieldBoundary = function(field_id) {
      if (!App.layer_store.exists(field_id)) {
        App.layer_store.empty();
        return App.layer_store.loadField(field_id, {
          fillOpacity: 0.0
        });
      }
    };

    DataSidebarService.prototype.checkArray = function(array, value) {
      var i, item, len;
      for (i = 0, len = array.length; i < len; i++) {
        item = array[i];
        if (item === value) {
          return true;
        }
      }
      return false;
    };

    return DataSidebarService;

  })(Service);

}).call(this);
